import React, { useEffect, useRef, useState } from "react";
import styles from "./scss/createdropdown.module.scss";
import { Menu, Dropdown, Modal, Select } from "antd";
//import CreateTaskCenter from "../rightsidebar/taskcreatecenter";

import NewEventRightCenter from "../rightsidebar/neweventcenter";
import { URButton } from "../../../shared/widgets/button";
import CreatePrivateGroup from "../../contacts/leftsidebar/CreateNewGroup/privategroupindex";
import { useSelector } from "react-redux";
import { chats, contacts, initialStateModel, profileDetails } from "../../../models/model";
import { SearchFilter } from "../../../base/utils";
import { useHistory } from "react-router-dom";
import { ChatService } from "../../../base/chatService";
import store from "../../../context/store/store";
import { Types } from "../../../context/action/action";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { filterGrpContact, toastInformation, userStatusColor } from "../../../base/callService/common";
import Createnote from "../../../shared/components/Note/createNote";
import Createtask from "../../../shared/components/Task/createTask";
import { SocketChatService } from "../../../base/socketChatService";
import { chatTeamValidation, generateChatID, userInfo } from "../../../base/socketChatService/utils";
// import teamicon from "../../../styles/images/groupchat.svg";
// import eventicon from "../../../styles/images/eventicon.svg";
// import taskicon from "../../../styles/images/taskicon.svg";
// import notesicon from "../../../styles/images/notesicon.svg";
// import meetingicon from "../../../styles/images/meetingicon.svg";
// import callsicon from "../../../styles/images/callsicon.svg";
// import chaticon from "../../../styles/images/chatmsg.svg";

import teamicon from "../../../styles/images/Group_new.svg";
import eventicon from "../../../styles/images/Calendar_new.svg";
import taskicon from "../../../styles/images/Task_new.svg";
import notesicon from "../../../styles/images/Note_new.svg";
import meetingicon from "../../../styles/images/Video_new.svg";
import callsicon from "../../../styles/images/Call_new.svg";
import chaticon from "../../../styles/images/Chat_new.svg";

import { callMainPageInterface, currentCallDetail } from "../../../models/callModel";
import { storeHoldTeam } from "../../../base/callService/store_mining";
import { clearArchiveMessage } from "../../../base/socketChatService/newChat";
import MemberLists from "../../call/callsWidgets/memberList";
import _ from "lodash";
import { initiateCall, initiateGroupCall} from "../../../base/callService/callService";
import { totalmem } from "os";
import CancelVideoRequest from "../../call/callsDialPad/imcomingVideocall/cancelVideorequest";
import LetsMeetNow from "../../meeting/meetingWidgets/popUp/letsMeetNow";

type creategroupState = {
  contactList: Array<any>,
  searchContactList: Array<any>,
  addmember: Array<any>,
  isEventOpen: boolean,
  tempAllContacts: Array<any>,
  allContacts: Array<any>,
  searchText: string,
  chooseParticipants: Array<any>
  phoneNum: any
  totalUsers:Array<any>,
  companyContacts:Array<any>
}

type MeetingTopScreenState = {
  isMeetNow: boolean;
  isJoinMeet: boolean;
  isPersonalId: boolean;
  isAudio: boolean;
  isVideo: boolean;
};
 function CreateDropDown() {
  //const chatWindowDetails: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);


  const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let { isVideoRequestSent}: profileDetails = useSelector((state: any) => state.profileReducer);
  const{planBased}=useSelector((state:any) => state.meetingReducer);
  const workContacts: any = contactList.workContacts;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isNewMessage, setNewMessage] = useState(false);
  //const [isGroupModel, setisGroupModel] = useState(false);
  const [openNoteModel, setNoteModel] = useState(false);
  const [openTaskModel, setTaskModel] = useState(false);
  const [openTeamCall, setTeamCall] = useState(false);
  const [planValid, setPlanValid] = useState(false);
  const [isPlanValid ,setIsPlanValid] = useState(false);
  const [groupCallbtn, setGroupCallbtn] = useState(false);
  const selectRef = useRef(null);
  const GroupCall = planBased.find((item:any) => item.featureid === 49);
 
  const [getData, setData] = useState<MeetingTopScreenState>({
    isMeetNow:false,isJoinMeet:false,isPersonalId:false,isAudio:false,isVideo:true
  });
  const [teamDetails, setDetails] = useState<creategroupState>({
    addmember: [], 
    contactList: workContacts, searchContactList: workContacts, isEventOpen: false, tempAllContacts: [], allContacts: [], searchText: '', chooseParticipants: [], phoneNum: [],totalUsers:[],companyContacts:[]
  });

  let { allContacts, tempAllContacts, chooseParticipants, searchText, phoneNum,totalUsers } = teamDetails;
  const { contactReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  const callReducer: currentCallDetail = store.getState().updatedCallList || [];
  let history = useHistory();

  let companyContacts = contactReducer.workContacts;
  let teamList: Array<any> = contactReducer.teamContacs;
  let searchableContact: Array<any> = companyContacts?.concat(teamList);

  useEffect(() => {
    setDetails({ ...teamDetails, searchContactList: workContacts, contactList: workContacts });
  }, [workContacts.length, teamDetails.contactList.length]);

  useEffect(() => {
    // {chatleftside Group call}
   if (GroupCall && GroupCall.value1 === "Yes") {
    setGroupCallbtn(false); 
   } else {
    setGroupCallbtn(true);
   }
 
 }, [planBased]);

  const openNote = (data: boolean) => {
    setNoteModel(data);
  };

  const openTask = (data: boolean) => {
    setTaskModel(data);
  };
  // const isCallsDisabled = planBased && planBased?.Group_call === "Yes";

  // const handleOk = () => {
  //   setIsModalVisible(false);
  // };

  const handleCancel = () => {
    setIsModalVisible(false);
    setNewMessage(false);
    setDetails({ ...teamDetails, addmember: [], isEventOpen: false });
  };

  const showGroupModal = (status: boolean) => {

    
    chatTeamValidation(status);
    //setisGroupModel(status);
  };

  // const openCallWindow = () => {
  //   if (callReducer.callDetails.length === 0) {
  //     callPlusIconAction(true, "quickCall");
  //     if (history.location.pathname === "/calls") {
  //       popoutStores();
  //     }
  //   } else {
  //     toastInformation("Already You are in call", "failure");
  //   }
  // };

  const closeTeamCall = () => {
    setTeamCall(false)
    setDetails({ ...teamDetails, searchText: '', chooseParticipants: [], phoneNum: [] ,totalUsers:[]});
  }

  /**
   * Enable New Message Modal
   */
  const enableNewMessageModal = () => {
    // setNewMessage(true);
    history.push("/chats");

    store.dispatch({
      type: Types.DROPDOWN_NEWCHAT,
      payload: {
        dropdownNewChat: false
      }
    });
    store.dispatch({
      type: Types.OPEN_NEW_MESSAGE,
      payload: {
        isNewMessageWindow: true,
        newUserMessage: [],
        newUserDetails: []
      }
    });


    store.dispatch({
      type: Types.UPDATE_TEAM_MEMBER,
      payload: {
        newUserMembers: []
      }
    });

    store.dispatch({
      type: Types.MULTI_NEWMESSAE,
      payload: {
        isMultiNewUserchat: false,
        multiMemberList: []
      }
    });
    store.dispatch({
      type: Types.SET_CONTACT_WINDOW,
      payload: {
        chatWindowDetails: {}
      }
    });


    clearArchiveMessage();

    store.dispatch({
      type: Types.STORE_ARCHIVE_MESSAGE,
      payload: {
        archiveMessageArray: []
      }
    });
    chat_reducer.isWindowSlide && ChatService.rightSideToogle();
    chat_reducer.replyMessageDetails.isReply && ChatService.onChangeReplyWindow(false, {});
    chat_reducer.editMessageDetails.isEditing && ChatService.editDraft(false);
  };

  const enterChat = () => {
    let members = teamDetails?.addmember;
    let lists = contactList?.allContacs?.filter(
      (data: any) => members !== undefined && members.indexOf(data.sip_login_id) !== -1
    );
    if (lists.length > 1 || lists.length === 0) {
      store.dispatch({
        type: Types.OPEN_NEW_MESSAGE,
        payload: {
          isNewMessageWindow: true,
          newUserMessage: teamDetails.addmember,
          newUserDetails: lists
        }
      });
      history.push("/chats");
      setNewMessage(false);
      setDetails({ ...teamDetails, addmember: [] });
      store.dispatch({
        type: Types.STORE_ARCHIVE_MESSAGE,
        payload: {
          archiveMessageArray: []
        }
      });
    } else {
      const chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
      if (Array.isArray(lists) && lists.length === 1) {
        const chatWindowDetails: any = lists[0];

        if (chatWindowDetails?.sip_login_id) {
          let chatDetail = { chatId: generateChatID(userInfo().fromID, chatWindowDetails.sip_login_id.toString()) };
          chatService.openChatWindow(chatWindowDetails, history, chatDetail);
        } else if (chatWindowDetails?.team_id) {
          chatService.openChatWindow(chatWindowDetails, history);
        }

        ChatService.editDraft("");
        setNewMessage(false);
        setDetails({ ...teamDetails, addmember: [] });
      }
    }
  };

  const onChangeaddMembers = (value: any) => {
    if (value.length) {
      store.dispatch({
        type: Types.STORE_ARCHIVE_MESSAGE,
        payload: {
          archiveMessageArray: []
        }
      });
    }

    setDetails({ ...teamDetails, addmember: value, searchContactList: teamDetails.contactList });
  };

  const onSearchMembers = (value: any) => {
    let response = SearchFilter(teamDetails?.contactList, value);
    setDetails({ ...teamDetails, searchContactList: response });
  };
  const eventNewModal = () => {
    setDetails({ ...teamDetails, isEventOpen: true });
  };
  const openTeamModal = () => {
    setDetails({ ...teamDetails, allContacts: searchableContact, tempAllContacts: searchableContact });
    setTeamCall(!openTeamCall);
    setPlanValid(false);
    setIsPlanValid(false);

  };
  const menu = (
    <Menu className="ppops">
      <Menu.Item onClick={enableNewMessageModal}><img src={chaticon} alt="" />Chat</Menu.Item>
      <Menu.Item onClick={() => showGroupModal(true)}><img src={teamicon} alt="" />Group</Menu.Item>
      <Menu.Item onClick={openTeamModal} 
      // disabled = {isCallsDisabled} 
        // className={isCallsDisabled ? 'ant-menu-item-disabled' : ''}
        // style={isCallsDisabled ? { cursor: 'default', color: '#ccc' } : {}}
        >
        <img src={callsicon} alt="" 
        // className={isCallsDisabled ? 'disabled-img' : ''}
        />Calls <div className={styles.smallText}>(Single/Group)</div></Menu.Item> 
      <Menu.Item onClick={() => meetinNowPopupStatus(true)}><img src={meetingicon} alt="" />Meeting</Menu.Item>
      {/* <Menu.Item onClick={() => openNote(true)}><img src={notesicon} alt="" />Note</Menu.Item>
      <Menu.Item onClick={() => openTask(true)}><img src={taskicon} alt="" />Task</Menu.Item>
      <Menu.Item onClick={eventNewModal}><img src={eventicon} alt="" />Event</Menu.Item> */}
    </Menu>
  );


  let favourtieList: any = teamDetails?.searchContactList.filter((contact: any) => { return contact.is_favourite === 1 })
 
  const change = (val: any, obj: any) => {
     let allUsers:Array<any>=[];
     if (typeof val === 'number') {
      val = [val];
    }
     if (Array.isArray(val)) {
      val.map((key: any) => {
        let keyStr = key.toString();
        if (keyStr.includes('con')) {
          let groupId: string = keyStr.replace('con', '');
        let {members}:any = filterGrpContact((groupId), false);
        allUsers.push(...Object.keys(members))
        }
        else{
          allUsers.push(keyStr)
        }
    
      })
     } else {
      console.warn("Expected val to be an array or string, but got:", val);
     }
    allUsers.push(...phoneNum)
    if(allUsers.length<=100){
      setDetails({
        ...teamDetails, chooseParticipants: val,
        allContacts: searchableContact,totalUsers:allUsers
      });
      setPlanValid(true);

    }
    else{
      toastInformation('Maximum participants reached','warning')
    }
   

  };

  const searchContact = (e: any) => {
    let searchName = e.toLowerCase();
    if(GroupCall && GroupCall.value1 === "Yes")
    {
      if (searchName !== "") {
        let filtered = _.filter(tempAllContacts, function (name: any) {
          return name.caller_id?.toLowerCase().includes(searchName) ||
            name.ext?.toString().includes(searchName) || name.team_name?.toLowerCase().includes(searchName);
        });
        setDetails({ ...teamDetails, allContacts: filtered, searchText: searchName });
      }
      else { setDetails({ ...teamDetails, allContacts: tempAllContacts, searchText: '' }); }

    }
    else
    {
      if (searchName !== "") {
        let filtered = _.filter(tempAllContacts, function (name: any) {
          return name.caller_id?.toLowerCase().includes(searchName) ||
            name.ext?.toString().includes(searchName) || name.team_name?.toLowerCase().includes(searchName);
        });
        setDetails({ ...teamDetails, allContacts: filtered, searchText: searchName });
      }
      else { console.log("else"); setDetails({ ...teamDetails, allContacts: companyContacts, searchText: '' }); }

    }
  }

  const startTeamCall = () => {
    let totalUser: Array<any> = teamDetails.chooseParticipants.concat(teamDetails.phoneNum);
    let makeGroupCall:boolean=totalUser.length>1?true:( (totalUser[0].toString()).includes('con')?true:false);
  if(totalUsers.length>0 ){
    if(_.isEmpty(callReducer.callDetails) ){
      makeGroupCall? initiateGroupCall('multi', chooseParticipants, phoneNum):initiateCall(totalUser[0],'audio');
    }else{ 
    if(callReducer.callDetails[0].holdState === true){
      makeGroupCall? initiateGroupCall('multi', chooseParticipants, phoneNum):initiateCall(totalUser[0],'audio');
    }
      else{
      if (makeGroupCall) { storeHoldTeam(true, 'Group', chooseParticipants, phoneNum) }
      else {
        storeHoldTeam(true, 'Normal', totalUser[0]) }

    }
  }
}
  closeTeamCall()
}
   const handleNumbers = (value: any) => { 
    if(groupCallbtn && value.length > 1)
    {
      value.length =1;
    }

     let allUsers:any = [];
     if(totalUsers.length>0&&phoneNum.length>0){
      phoneNum.map((user:any)=>{
        let userIndex: number = totalUsers.indexOf(user);
        if(userIndex!==-1){
          totalUsers.splice(userIndex,1)
        }
      })}
     allUsers.push(...value, ...totalUsers)
     setIsPlanValid(true)

     if (allUsers.length <= 100) {
       setDetails({ ...teamDetails, phoneNum: value, totalUsers: allUsers });
     }
     else {
       toastInformation('Maximum participants reached', 'warning')
     }
   }

   const meetinNowPopupStatus = (action:boolean) => {
    setData({ ...getData, isMeetNow: action });
  };

  return (
    <>
      {contactList?.teamValidation ? <CreatePrivateGroup fromCallLog={false} groupLogUsers={[]} showGroupmodel={showGroupModal} isModel={contactList?.teamValidation} /> : null}
      <Dropdown overlay={menu} trigger={["click"]} placement="bottomLeft" className="openstatus">
        <h3>
          <span className="icon_plus"></span>Start
          <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span>
        </h3>
      </Dropdown>

    {isVideoRequestSent &&  <CancelVideoRequest openNote={openNote} open={true}/>} 

     {isNewMessage && <Modal visible={isNewMessage} className={`${styles.newmessage} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={handleCancel} />
        <h2>New Message</h2>
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="search by name / extension"
          value={teamDetails.addmember}
          className="newselects"
          dropdownClassName="newChatSel"
          onChange={(e: any) => onChangeaddMembers(e)} onSearch={onSearchMembers} showSearch={true}
          /*  optionLabelProp = "label" */ filterOption={false}>

          <option><div className="titlesdrop">Favourite / Frequently Contacted</div></option>
          {favourtieList?.map((contact: any, index: number) => {
            if (contact.is_favourite === 1) {
            }
            return (
              <option value={contact?.sip_login_id} key={index}>
                <div className="dropdowndesign">
                  <div className="usergroupss">
                    <URAvatarGroup className='lefts size20' profileInfo={<>
                      {contact.ImageURL ?
                        <img src={contact.ImageURL} alt="" /> :
                        <span>{contact.caller_id?.charAt(0)}</span>}
                      <URStatusDot
                        className={userStatusColor(contact?.user_status, 'small')} />
                    </>} />
                  </div>
                  <div className="names">{contact?.team_name ? contact?.team_name : contact?.caller_id}</div>
                  <div className="ext">{contact?.ext && contact?.ext}</div>
                </div>
              </option>
            );

          })}

          <option><div className="titlesdrop">Contact</div></option>
          {teamDetails?.searchContactList.map((contact: any, index: number) => {

            return (
              <option value={contact?.sip_login_id} key={index}>
                <div className="dropdowndesign">
                  <div className="usergroupss">
                    <URAvatarGroup className='lefts size20' profileInfo={<>
                      {contact?.ImageURL ?
                        <img src={contact?.ImageURL} alt="" /> :
                        <span>{contact?.caller_id?.charAt(0)}</span>}
                      <URStatusDot
                        className={userStatusColor(contact?.user_status, 'small')} />
                    </>} />
                  </div>
                  <div className="names">{contact?.team_name ? contact?.team_name : contact?.caller_id}</div>
                  <div className="ext">{contact?.ext && contact?.ext}</div>
                </div>
              </option>
            );
          })}

          <option>
            <div className="titlesdrop">Contact</div>
          </option>
          {teamDetails?.searchContactList.map((contact: any, index: number) => {
            return (
              <option value={contact?.sip_login_id} key={index}>
                <div className="dropdowndesign">
                  <div className="usergroupss">
                    <URAvatarGroup
                      className="lefts size20"
                      profileInfo={
                        <>
                          {contact?.ImageURL ? (
                            <img src={contact?.ImageURL} alt="" />
                          ) : (
                            <span>{contact?.caller_id?.charAt(0)}</span>
                          )}
                          <URStatusDot className={userStatusColor(contact?.user_status, "small")} />
                        </>
                      }
                    />
                  </div>
                  <div className="names">{contact?.team_name ? contact?.team_name : contact?.caller_id}</div>
                  <div className="ext">{contact?.ext && contact?.ext}</div>
                </div>
              </option>
            );
          })}
        </Select>
        <div className={styles.footersection}>
          <URButton className="urButton buttonWhite buttonMd mr8" name="Cancel" onClick={handleCancel}></URButton>
          <URButton className="urButton buttonBlue buttonMd" onClick={enterChat} name="Chat"></URButton>
        </div>
      </Modal> }

      {/* <Modal visible={isModalVisible} className={`${styles.newmessage} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} />
        <h2>
          Video Call <span className="icon_meet"></span>
        </h2>
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="search by name / extension"
          className="newselects"
        >
          <option>
            <div className="titlesdrop">Favourite / Frequently Contacted</div>
          </option>
          <option value="sdas13">
            <div className="dropdowndesign">
              <div className="usergroups">
                <span>
                  A<b></b>
                </span>
              </div>
              <div className="names">Adam Stewart</div>
              <div className="ext">185</div>
            </div>
          </option>
        </Select>
        <div className={styles.footersection}>
          <URButton className={styles.cancelbtn} name="Cancel"></URButton>
          <URButton className={styles.savebtn} onClick={handleCancel} name="Start"></URButton>
        </div>
      </Modal> */}

      {/* <Modal visible={isModalVisible} className={`${styles.newmessage} ${"modaloverwrite"} ${"notecreation"}`}>
        <span className={`icon_close ${styles.cursorTop}`} />
        <h2>New Note <span className="icon_event"></span></h2>
        <CreateNoteCenter></CreateNoteCenter>
        <div className={`${styles.footersection} ${"footersection"}`}>
          <URButton className={styles.cancelbtn} name="Cancel"></URButton>
          <URButton className={styles.savebtn} onClick={handleCancel} name="Save"></URButton>
        </div>
      </Modal> */}
      {openTaskModel &&  <Createtask openTask={openTask} open={openTaskModel} /> }
      {openNoteModel && <Createnote openNote={openNote} open={openNoteModel} />}
      {getData.isMeetNow && <LetsMeetNow leetsMeetNowStatus={meetinNowPopupStatus} meetDetails={getData} />}
      {/* <Modal visible={isModalVisible} className={`${styles.newmessage} ${"modaloverwrite"} ${"taskcreation"}`}>
        <span className={`icon_close ${styles.cursorTop}`} />
        <h2>New Task <span className="icon_ticknote"></span></h2>
        <CreateTaskCenter></CreateTaskCenter>
        <div className={`${styles.footersection} ${"footersection"}`}>
          <URButton className={styles.cancelbtn} name="Cancel"></URButton>
          <URButton className={styles.savebtn} onClick={handleCancel} name="Save"></URButton>
        </div>
      </Modal> */}

    {teamDetails.isEventOpen &&  <Modal visible={teamDetails.isEventOpen} className={`${styles.newmessage}
       ${"modaloverwrite"} ${"eventcreation"} ${"modalreactwidth"}`}>
        <NewEventRightCenter handleCancel={handleCancel}></NewEventRightCenter>
      </Modal> }
      
    {openTeamCall &&  <Modal visible={openTeamCall} className={`${styles.newmessage} ${"modaloverwrite"} ${"taskcreation"} `}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeTeamCall} />
        <h2> Audio Call {GroupCall && GroupCall.value1 === "Yes" && <span className={styles.userCountno}>({totalUsers.length}/100)</span>}</h2>
        <div className={styles.rightsidebar}>
          <div className={styles.middlelayers}>

 
                <label>Contact</label>
                <div className={styles.insideicon}>
                  <Select
                    // mode="multiple"
                    mode={GroupCall && GroupCall.value1 === "Yes" ? "multiple" : 'default'}
                    style={{ width: '100%' }}
                    /*  optionLabelProp="label" */
                    filterOption={false}
                    showSearch={true}
                    value={chooseParticipants}
                    defaultValue={chooseParticipants}
                    onSearch={searchContact}
                    placeholder="Enter name or extension"
                    className={`newselects ${GroupCall && GroupCall.value1 === "Yes" ? "" : 'modechangeselect'}`}
                    onChange={change}
                    disabled={( groupCallbtn &&teamDetails?.phoneNum>0)}
                    allowClear={groupCallbtn} 
                  >
                    {MemberLists(searchText, allContacts, true)}
                  </Select>
                </div>


            {/* <URInput placeHolder="Type numbers separated by space" name="" value={phoneNum} className={`hoverbdrBlue  ${styles.normalinput}`}  onChange={handleNumbers} />    */}
            <label>Phone Number</label>
            <Select
              mode="tags"
              // mode={planBased?.Group_call === 'Yes' ? 'default' : "tags"}
              ref={selectRef}
              style={{ width: '100%' }}
              showSearch={false}
              value={phoneNum}
              // labelInValue
              placeholder="Type numbers separated by space"
              className="newselects"
              // className={`hoverbdrBlue  ${styles.normalinput}`}
              onChange={handleNumbers}
              tokenSeparators={[' ', ',']}
              filterOption={false}
            // inputValue={'numbers'}
            // defaultValue={''}
            //disabled
            disabled={(groupCallbtn && teamDetails?.chooseParticipants?.length > 0)}
            >
            </Select>

          </div>
        </div>
        <div className={`${styles.footersection} ${"footersection"} padlrzero `}>
          <URButton className="urButton buttonWhite " name="Cancel" onClick={closeTeamCall}></URButton>
          <URButton className={`${(teamDetails?.chooseParticipants?.length > 0 ||teamDetails?.phoneNum>0)? "urButton buttonBlue marlftmin" : 
          "urButton buttonBlue disabled hidecursor"}`}  onClick={startTeamCall} name="Start"></URButton>
            
        </div>
      </Modal>}
    </>
  );};

  export default React.memo(CreateDropDown);